"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = `
query read($id: Int!) {
  coachTrainee(id: $id) {
    currentPeriod {
      calorieBudgets {
        week
        calories
        carbohydrates
        fats
        proteins
        isForTrainingDays
        fibers
        isSecured
      }
    }
  }
}`;
//# sourceMappingURL=getCalorieBudget.js.map